/**
 * Replaces the product slug in a URL while preserving query parameters
 * @param currentUrl - The current URL (e.g., window.location.href)
 * @param newProductSlug - The new product slug to replace with
 * @returns The new URL with the replaced product slug
 */
export function replaceProductSlugInUrl(currentUrl: string, newProductSlug: string): string {
  try {
    // Decode the URL first to handle any encoded characters
    const decodedUrl = decodeURIComponent(currentUrl);
    const url = new URL(decodedUrl);
    
    // If newProductSlug contains a full path, extract the product slug and query parameters
    let cleanProductSlug = newProductSlug;
    let queryParams = '';
    if (newProductSlug.includes('/products/')) {
      // Extract everything between /products/ and the next / or ?
      const match = newProductSlug.match(/\/products\/([^/?]+)(.*)/);
      if (match) {
        cleanProductSlug = match[1];
        queryParams = match[2]; // This will include the ? and query parameters
      }
    }
    
    // Get the base path (everything before the product slug)
    const basePath = url.pathname.split('/products/')[0];
    
    // Construct the new URL with the base path, new product slug, and query parameters from newProductSlug
    const newUrl = `${url.origin}${basePath}/products/${cleanProductSlug}${queryParams}`;
    
    return newUrl;
  } catch (error) {
    console.error('Error replacing product slug in URL:', error);
    return currentUrl; // Return original URL if there's an error
  }
}
